

import { Component, Vue, Watch } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

import "vue-cal/dist/vuecal.css"
import { Route } from "vue-router"
import { getStylesheetName } from "./utils/ThemeLoader"

import "quill/dist/quill.core.css" // import styles
import "quill/dist/quill.snow.css" // for snow theme
import { BaseState, StateRouter } from "@/store"

@Component({
	components: {}
})
export default class App extends Vue {
	@Mutation public setScreenWidth!: (width: number) => void;
	@Mutation public setDarkMode!: (darkMode: boolean) => void;

	@State public darkMode!: boolean
	@State public router!: StateRouter | null
	@State((state: BaseState) => state.interfaceLoading) interfaceLoading!: boolean

	@Getter("getScreenWidth") public screenWidth!: number;
	@Getter("getStylesheet") public stylesheet!: string;

	@Action public startUp!: () => void;

	public async created () {
		const link = document.createElement("link")
		link.id = "lightdark"
		link.rel = "stylesheet"

		const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches

		link.href = this.stylesheet

		document.head.appendChild(link)

		console.log("Theme", isDarkMode)
		this.setDarkMode(isDarkMode)
	}

	@Watch("$route")
	onRouteChanged (to: Route, from: Route) {
	}

	@Watch("stylesheet")
	private onStyleSheetChanged (newTheme: string): void {
		const themeLink = document.getElementById("lightdark") as HTMLLinkElement
		if (themeLink) {
			const currentTheme = themeLink.getAttribute("href")
			if (currentTheme !== newTheme) {
				console.info("Theme change", currentTheme, newTheme)
				themeLink.href = newTheme
			}
		}
	}

	public async mounted () {
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				this.setScreenWidth(screen.width)
			})
			this.setScreenWidth(screen.width)
		})

		this.$router.onReady(this.startUp)
	}

	private get themeColours (): string {
		return this.darkMode ? "dark" : "light"
	}
}
